// extracted by mini-css-extract-plugin
module.exports = {"technologies__image":"technologies-section_technologies__image__H5ALH"};